import { useQuery } from 'react-query';
import {
  communicationTemplateKeys,
  parseCommunicationTemplateKey,
} from '../cache-keys/communicationTemplateKeys';
import { useAPI } from '@axo/shared/data-access/provider';
import { comment_template_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../query-function';

export function useCommentTemplates(marketCountry: string | undefined) {
  const api = useAPI();
  const cacheKey = communicationTemplateKeys.commentTemplates({
    marketCountry,
  });

  return useQuery(
    cacheKey,
    queryFunction(
      comment_template_api.find(api),
      ({ queryKey }) =>
        parseCommunicationTemplateKey(queryKey).marketCountry ?? ''
    ),
    {
      enabled: !!marketCountry,
    }
  );
}
